import React from 'react';
import * as Styled from '../../carousel-lite.styled';
import { dataAttrGUI } from '@at/formatter-utils';
export var CarouselSkeleton = function (_a) {
    var _b;
    var loadingSlidesCount = _a.loadingSlidesCount, loadingCardSize = _a.loadingCardSize, uniqueId = _a.uniqueId, width = _a.width;
    var _c = loadingCardSize !== null && loadingCardSize !== void 0 ? loadingCardSize : {}, $width = _c.$width, $height = _c.$height;
    var loadingCardWidth = $width !== null && $width !== void 0 ? $width : 300;
    var loadingCardHeight = $height !== null && $height !== void 0 ? $height : 300;
    return (React.createElement(Styled.CarouselLiteLoadingSkeleton, (_b = {}, _b[dataAttrGUI] = "".concat(uniqueId, "-skeleton"), _b),
        React.createElement(Styled.CarouselLiteLoadingBody, null,
            React.createElement(Styled.CarouselLiteBodyWindow, { style: { width: "".concat(width, "px") } }, Array.from({ length: loadingSlidesCount }).map(function (_, index) { return (React.createElement(Styled.CarouselLiteLoadingItem, { key: "carousel-loading-item-".concat(index), "$width": loadingCardWidth, "$height": loadingCardHeight })); })))));
};
